<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 pt-4 pb-5">
          <router-link to="/business" class="link text-underline">
            <i class="icon-back"></i> 回到商機專區首頁
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="overview">
            <div class="list"
            v-for="(list, lid) in menu" :key="`menu-${lid}`">
              <h4 class="text-green">{{list.name}}</h4>
              <a class="item"
              v-for="(item, i) in list.child"
              :key="`list-child-${i}`">
                {{ item.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>  
</template>

<script>
export default {
  name: 'Overview',
  data () {
    return {
      menu: [
        {
          name: '保費訊息',
          child: [
            {name: '保價不足預警通知名單'},
            {name: '次月待扣名單'},
            {name: '扣款不成通知名單'},
            {name: '保單停效名單'}
          ]
        },
        {
          name: '關係建立',
          child: [
            {name: '保價不足預警通知名單'},
            {name: '次月待扣名單'},
            {name: '扣款不成通知名單'},
            {name: '保單停效名單'}
          ]
        },
        {
          name: '更多項目3',
          child: [
            {name: '小項目名稱1'},
            {name: '小項目名稱2'},
            {name: '小項目名稱3'},
            {name: '小項目名稱4'}
          ]
        },
        {
          name: '回流再購',
          child: [
            {name: '滿期金目標名單'},
            {name: '年金目標名單'},
            {name: '結構債保單滿期查詢'},
            {name: '結構債保單配息查詢'},
            {name: '現金配息保單配息查詢'}
          ]
        },
        {
          name: '整合行銷',
          child: [
            {name: '當季(年度)信用卡目標客戶'},
            {name: '當季(年度)本月及下月有車險續保的客戶'}
          ]
        },
        {
          name: '更多項目4',
          child: [
            {name: '小項目名稱1'},
            {name: '小項目名稱2'},
            {name: '小項目名稱3'}
          ]
        },
        {
          name: 'VIP',
          child: [
            {name: 'VIP升等目標名單'},
            {name: 'VIP尊榮服務名單'},
            {name: 'VIP符合免費健檢名單'},
            {name: '當年度VIP活動目標名單'}
          ]
        },
        {
          name: '更多項目4',
          child: [
            {name: '小項目名稱1'},
            {name: '小項目名稱2'}
          ]
        },
        {
          name: '更多項目5',
          child: [
            {name: '小項目名稱1'},
            {name: '小項目名稱2'},
            {name: '小項目名稱3'},
            {name: '小項目名稱4'},
            {name: '小項目名稱5'}
          ]
        },
        {
          name: '商品/保障',
          child: [
            {name: '已/未購買投資型商品名單'},
            {name: '實支實付目標客戶'}
          ]
        },
      ]
    }
  }
}
</script>
